<template>
  <div class="mb-3 col-12">
    <b-table v-if="itemsFiltrados && itemsFiltrados.length > 0" striped responsive small :items="itemsFiltrados"
      :fields="fieldsTable">
      <template #cell(realizado)="data">
        <input type="checkbox" :checked="data.item.realizado" @change="toggleRealizado(data.item)" />
      </template>

      <template #cell(fecha_realizacion)="data">
        {{ formatFecha(data.item.fecha_realizacion) }}
      </template>

        <template #cell(lado)="data">
        {{ namePieza(data.item.procedimiento, data.item.lado) }}
      </template>
      <!-- Diagnóstico 1 -->
      <template #cell(diagnostico_1)="data">
        <v-select :options="opcionesDiagnosticos" v-model="data.item.diagnostico_1" placeholder="Seleccione o escriba"
          label="text" @search="onSearchDiagnosticos" :loading="searchDiagnosticos.loading" clearable
          @input="actualizarDiagnostico(data.item, 'diagnostico_1', $event)">
          <template #no-options>
            {{ noDiagnosticosMessage() }}
          </template>
        </v-select>
      </template>

      <!-- Diagnóstico 2 -->
      <template #cell(diagnostico_2)="data">
        <v-select :options="opcionesDiagnosticos" v-model="data.item.diagnostico_2" placeholder="Seleccione o escriba"
          label="text" @search="onSearchDiagnosticos" :loading="searchDiagnosticos.loading" clearable
          @input="actualizarDiagnostico(data.item, 'diagnostico_2', $event)">
          <template #no-options>
            {{ noDiagnosticosMessage() }}
          </template>
        </v-select>
      </template>
      <!-- Procedimiento -->
      <template #cell(procedimiento)="data">
      <div>
        {{ getProcedimientoText(data.item.procedimiento) }}
      </div>
      </template>
      <!-- Procedimiento -->
      <template #cell(procedimiento_cie)="data">
          <v-select :options="opcionesProcedimientos" v-model="data.item.procedimiento_cie" placeholder="Seleccione o escriba"
          label="text" @search="onSearchProcedimientos" :loading="searchProcedimientos.loading" clearable
          @input="actualizarProcedimiento(data.item, 'procedimiento_cie', $event)">
          <!-- <template #no-options>
            {{ noDiagnosticosMessage() }}
          </template> -->
        </v-select>
      </template>

      <!-- Procedimiento -->
      <template #cell(doctor)="data">
      
         <v-select v-if="!userDoctor && !data.item.doctor" :options="opcionesDoctor" v-model="data.item.doctor" placeholder="Seleccione o escriba"
          label="text"  @search="onSearchDoctor" :loading="searchDoctor.loading" clearable
          @input="actualizarDoctor(data.item, 'doctor', $event)">
          <!-- <template #no-options>
            {{ noDiagnosticosMessage() }}
          </template> -->
        </v-select>
          <div v-else>
            <label>{{ doctorExists(data.item) }}</label>
          </div>
         
      </template>

      <template #cell(acciones)="data">
  <button
    class="btn btn-sm btn-danger"
    @click="eliminarItem(data.item)"
    :disabled="data.item.realizado"
    title="Eliminar fila"
  >
    <i class="fa-solid fa-trash"></i>
  </button>

  <!-- <button
    class="btn btn-sm btn-danger"
    @click="enviarImagen(data.item)"
    
    title="Enviar Imagen"
  >
    <i class="fa-solid fa-trash"></i>
  </button> -->
</template>

    </b-table>
  </div>
</template>

<script>
import { BTable } from 'bootstrap-vue';
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { diagnosticosService } from '../../../atencionMedica/services';
import { odontoServices } from '../../../odontologia/services/odontoServices';
import { getEstablecimientoLS, getInfoDoc } from '../../../../shared/helpers';
import { doctoresService } from '../../../administracion/services';

export default {
  name: 'TableOdontograma',
  components: {
    BTable,
    vSelect
  },
  props: {
    items: {
      type: Array,
      default: () => [],
      required: false
    }
  },

  async created(){
    const doctorSession = await this.getDataDoc()
    console.log(doctorSession)
   
    if(doctorSession) {this.userDoctor = true}
  },

  data() {
    return {
      optionsProcedimiento: [
        { text: 'Caries en la zona', value: 'caz', disabled: false },
        { text: 'Caries en toda la pieza', value: 'cap', disabled: false },
        { text: 'Extraer/Extraida', value: 'ext', disabled: false },
        { text: 'Corona en pieza', value: 'cop', disabled: false },
        { text: 'Sellante', value: 'sellante', disabled: false },
        { text: 'Endodoncia', value: 'end', disabled: false },
        { text: 'Cavidad encontrada', value: 'enc', disabled: false },
        { text: 'Cuello base cavitaria', value: 'cuello', disabled: false },
        { text: 'Restauración', value: 'restauracion', disabled: false },
        { text: 'Incrustación', value: 'incrustacion', disabled: false },
        { text: 'Retratamiento', value: 'retratamiento', disabled: false },
        { text: 'Recromía', value: 'recromia', disabled: false },
        { text: 'Carilla', value: 'carilla', disabled: false },
        { text: 'Alargamiento corona', value: 'alargamiento_corona', disabled: false },
        { text: 'Profilaxis', value: 'profilaxis', disabled: false },
        { text: 'Aplicación de flúor en gel', value: 'aplicacion_fluor_gel', disabled: false },
        { text: 'Aplicación de flúor barniz', value: 'aplicacion_fluor_barniz', disabled: false },
        { text: 'Microabrasión', value: 'microabrasion', disabled: false },
        { text: 'Sensibilidad', value: 'sensibilidad', disabled: false },
        { text: 'Retracción', value: 'retraccion', disabled: false },
        { text: 'Cirugía', value: 'cirugia', disabled: false },
        { text: 'Movilidad dental', value: 'movilidad_dental', disabled: false },
        { text: 'Furca', value: 'furca', disabled: false },
        { text: 'Odontosección', value: 'odontoseccion', disabled: false },
        { text: 'Restos radiculares', value: 'restos_radiculares', disabled: false },
        { text: 'Prótesis removible', value: 'protesis_removible', disabled: false },
        { text: 'Prótesis total', value: 'protesis_total', disabled: false },
        { text: 'Puente', value: 'puente', disabled: false },
        { text: 'Perno', value: 'perno', disabled: false },
        { text: 'Periodoncia', value: 'periodoncia', disabled: false },
        { text: 'Odontoma', value: 'odontoma', disabled: false },
        { text: 'Quiste', value: 'quiste', disabled: false },
        { text: 'Blanqueamiento', value: 'blanqueamiento', disabled: false },
        { text: 'Férula', value: 'ferula', disabled: false },
        { text: 'Placa miorelajante', value: 'placa_miorelajante', disabled: false },
        { text: 'Control ortodoncia', value: 'control_ortodoncia', disabled: false },
        { text: 'Sin espacio', value: 'sin_espacio', disabled: false },
        { text: 'Supernumerario', value: 'supernumerario', disabled: false },        
      ],

      userDoctor: false,
      isLoading: false,

      searchDiagnosticos: {
        query: '',
        isLoading: false,
        searchFailed: false,
        selected: null
      },

      
      searchProcedimientos: {
        query: '',
        isLoading: false,
        searchFailed: false,
        selected: null
      },

      searchDoctor: {
        query: '',
        isLoading: false,
        searchFailed: false,
        selected: null
      },
      itemsFiltrados: [],

      // Campos de la tabla
      fieldsTable: [
        { key: 'number', label: '# Pieza', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
        { key: 'lado', label: 'Lado', sortable: true },

        // ✅ Fijar ancho en campos de diagnóstico
        {
          key: 'diagnostico_1',
          label: 'Diagnóstico 1',
          sortable: true,
          thStyle: 'width: 220px; min-width: 220px;',
          tdStyle: 'width: 220px; min-width: 220px;',
        },
        {
          key: 'diagnostico_2',
          label: 'Diagnóstico 2',
          sortable: true,
          thStyle: 'width: 220px; min-width: 220px;',
          tdStyle: 'width: 220px; min-width: 220px;',
        },

        // ✅ Las siguientes columnas son completamente responsive
        { key: 'procedimiento', label: 'Procedimiento', sortable: true },
        { key: 'procedimiento_cie', label: 'Cie Procedimiento', sortable: true },
        { key: 'doctor', label: 'Medico', sortable: true },
        { key: 'realizado', label: 'Realizado', sortable: true },
        { key: 'fecha_realizacion', label: 'Fecha realización', sortable: true },
        { key: 'acciones', label: 'acciones', thStyle: 'width: 40px; min-width: 40px;', tdClass: 'text-center' }
      ],


      // Lista de diagnósticos disponibles
      opcionesDiagnosticos: [

      ],
      opcionesProcedimientos: [

      ],
      opcionesDoctor: [

      ]
    };
  },

  methods: {
    normalizeSelectOption(rawOption) {
      if (rawOption == null) return null;

      if (typeof rawOption !== 'object') {
        return {
          text: String(rawOption),
          value: rawOption,
        };
      }

      const value =
        rawOption.value ??
        rawOption.id ??
        rawOption.procedimientoId ??
        rawOption.procOdontoId ??
        rawOption.codigo ??
        rawOption.cod ??
        null;

      const textBase =
        rawOption.text ??
        rawOption.label ??
        rawOption.descripcion ??
        rawOption.nombre ??
        rawOption.detalle ??
        null;

      const text =
        textBase ??
        (rawOption.codigo && rawOption.descripcion
          ? `[${rawOption.codigo}] ${rawOption.descripcion}`
          : null) ??
        (value != null ? String(value) : '');

      return {
        ...rawOption,
        text,
        value: value ?? text,
      };
    },
        getDataDoc() {
    const dataDoc = getInfoDoc()
    return dataDoc
  },
     doctorExists(item) {
    
    let doc_data = item?.doctor || ''
    if (!doc_data) {
      const dataDoc = this.getDataDoc()
      doc_data = `${dataDoc.primerApellido} ${dataDoc.primerNombre}`
     
      
    } 
    
    return doc_data
  },
    namePieza(value, lado) {
  if (value !== 'caz' && value !== 'enc' ) return '-';
  
  
  switch (lado) {
    case 'center':
      return "oclusal";
    case 'right':
      return "distal";
    case 'left':
      return "mesial";
    case 'top':
      return "vestibular";
    case 'bottom':
      return "lingual";
    default:
      return "-";
  }
 
},
  eliminarItem(item) {
  if (item.realizado) {
    alert('No se puede eliminar un ítem realizado.');
    return;
  }

  const tokenAEliminar = item.token;



  // 🧹 2. Eliminar de la tabla visual
  this.itemsFiltrados = this.itemsFiltrados.filter(i => i.token !== tokenAEliminar);

  // 🧹 3. Eliminar de Vuex
  this.$store.commit('removeToothStateByToken', tokenAEliminar);

  // ✅ 4. Emitir nuevo estado
  this.emitirDatos();
},

    actualizarDiagnostico(item, campo, valor) {
      // Actualiza el valor en itemsFiltrados
      item[campo] = valor;

      // Emitimos para que el padre sepa que hubo un cambio y pueda actualizar su array original
      this.emitirDatos();
    },
        actualizarDoctor(item, campo, valor) {
      // Actualiza el valor en itemsFiltrados
      item[campo] = valor?.text

      // Emitimos para que el padre sepa que hubo un cambio y pueda actualizar su array original
      this.emitirDatos();
    },
     actualizarProcedimiento(item, campo, valor) {
      // Actualiza el valor en itemsFiltrados
      item[campo] = valor;

      // Emitimos para que el padre sepa que hubo un cambio y pueda actualizar su array original
      this.emitirDatos();
    },

    emitirDatos() {
      
      this.$emit('update-items', this.itemsFiltrados);
    },
    formatFecha(fecha) {
      if (!fecha) return '';
      const d = new Date(fecha);
      const pad = (n) => n.toString().padStart(2, '0');

      const dd = pad(d.getDate());
      const mm = pad(d.getMonth() + 1);
      const YY = d.getFullYear().toString().slice(-2);
      const HH = pad(d.getHours());
      const MM = pad(d.getMinutes());

      return `${dd}--${mm}--${YY}-${HH}::${MM}`;
    },

    // Cambia el estado realizado y actualiza la fecha_realizacion
    toggleRealizado(item) {
      item.realizado = !item.realizado;
      if (item.realizado) {
        item.fecha_realizacion = new Date().toISOString();
      } else {
        item.fecha_realizacion = null;
      }
      this.emitirDatos(); // emitir los datos actualizados si es necesario
    },
    getProcedimientoText(value) {
      if (!value) return ''; // o algún texto por defecto

      const found = this.optionsProcedimiento.find(opt => opt.value === value);
      return found ? found.text : value; // si no encuentra, muestra el valor crudo
    },
    noDiagnosticosMessage() {
      if (this.searchDiagnosticos.query.length <= 3)
        return 'Escribe más caracteres para buscar...';

      if (this.searchDiagnosticos.isLoading)
        return 'Buscando diagnosticos...';

      if (this.searchDiagnosticos.searchFailed)
        return 'Error al buscar diagnosticos. Intente de nuevo.';

      if (this.opcionesDiagnosticos.length === 0 && !this.isLoading)
        return 'No se encontraron diagnosticos que coincidan con tu búsqueda';

      return 'Escribe para buscar diagnosticos...';
    },
    async filterDiagnosticos(query) {
      const diagnosticos = await diagnosticosService.getByQuerySelect(query);

      // Truncar el texto a max 30 caracteres y añadir "..." si es más largo
      const diagnosticosTruncados = diagnosticos.map(d => {
        const maxLength = 20;
        let truncatedText = d.text;
        if (truncatedText.length > maxLength) {
          truncatedText = truncatedText.slice(0, maxLength) + '...';
        }
        return {
          ...d,
          text: truncatedText
        };
      });

      return diagnosticosTruncados;
    },
     async filterProcedimientos(query) {


      const establecimiento = getEstablecimientoLS()?.id
      const odonto = await odontoServices.searchByTerm(query, establecimiento);
   

      // Truncar el texto a max 30 caracteres y añadir "..." si es más largo
      const services = odonto.map(d => {
        const maxLength = 20;
        let truncatedText = d.text;
        if (truncatedText.length > maxLength) {
          truncatedText = truncatedText.slice(0, maxLength) + '...';
        }
        return {
          ...d,
          text: truncatedText
        };
      });

      return services;
    },

     async filterDoctores(query) {


      const establecimiento = getEstablecimientoLS()?.id
      const doctorResponse = await doctoresService.searchDoctoresByTermSelect(query, establecimiento);
   

      // Truncar el texto a max 30 caracteres y añadir "..." si es más largo
      const doctores = doctorResponse.map(d => {
        const maxLength = 20;
        let truncatedText = d.text;
        if (truncatedText.length > maxLength) {
          truncatedText = truncatedText.slice(0, maxLength) + '...';
        }
        return {
          ...d,
          //text: truncatedText
        };
      });

      return doctores;
    },


    async onSearchDiagnosticos(query) {
      this.searchDiagnosticos.query = query;

      if (query.length < 2) {
        this.opcionesDiagnosticos = [];
        return;
      }

      this.searchDiagnosticos.isLoading = true;
      this.opcionesDiagnosticos = [];
      this.opcionesDiagnosticos = await this.filterDiagnosticos(query);
      this.searchDiagnosticos.isLoading = false;
    },

    
    async onSearchProcedimientos(query) {
      this.searchProcedimientos.query = query;

      if (query.length < 2) {
        this.opcionesProcedimientos = [];
        return;
      }

      this.searchProcedimientos.isLoading = true;
      this.opcionesProcedimientos = [];
      this.opcionesProcedimientos = await this.filterProcedimientos(query);
      this.searchProcedimientos.isLoading = false;
    },

      async onSearchDoctor(query) {
      this.searchDoctor.query = query;

      if (query.length < 2) {
        this.opcionesDoctor = [];
        return;
      }

      this.searchDoctor.isLoading = true;
      this.opcionesDoctor = [];
      this.opcionesDoctor = await this.filterDoctores(query);
      this.searchDoctor.isLoading = false;
    },

 
    emitirDatos() {
      this.$emit('update-items', this.itemsFiltrados);
    }
  },

  watch: {
    items: {
      deep: true,
      immediate: true,
      handler(newVal) {
        const ensureProcedimientoOption = (val) => {
          if (val == null) return null;
          const option = this.normalizeSelectOption(val);
          const exists = this.opcionesProcedimientos.some((opt) => {
            if (opt && option && opt.value != null && option.value != null) {
              return opt.value === option.value;
            }
            return false;
          });

          if (!exists) {
            this.opcionesProcedimientos = [...this.opcionesProcedimientos, option];
          }
          return option;
        };
        
        // Para evitar reemplazos innecesarios, comparar si hay diferencias (puedes hacer una comparación simple)
        const nuevosItems = newVal.map(element => ({
          number: element.piezaDetails?.number || element.number,
          lado: element.piezaDetails?.zone || element.lado,
          token: element.piezaDetails?.token || element.token,
          procedimiento_cie: ensureProcedimientoOption(
            element.procedimiento_cie ||
            element.procedimientoCie ||
            element.procedimiento_tarifario ||
            element.procedimientoTarifario ||
            element.procOdonto ||
            element.procOdontoId ||
            null
          ),
          doctor:element.doctor || null,
         
          diagnostico_1: element.diagnostico_1 || null,
          diagnostico_2: element.diagnostico_2 || null,
          procedimiento: element.procedimiento || null,
          fecha: element.fecha || null,
          fecha_realizacion: element.fecha_realizacion || null,
          realizado: element.realizado || null,
       
        }));

        // Comparar JSON stringificado (solo para arrays pequeños, si es muy grande usar librerías específicas)
        if (JSON.stringify(nuevosItems) !== JSON.stringify(this.itemsFiltrados)) {
          this.itemsFiltrados = nuevosItems;
          this.emitirDatos(); // Solo emitir si cambió realmente
        }
      }
    }
  }
};
</script>
